import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-351b6bfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "no-mb"
}

import { computed, onMounted } from 'vue'
import { generalStore } from '@/stores/general'
import { headerStore } from '@/stores/header'
import { authStore } from '@/stores/auth'
import { modularStore } from '@/stores/v2/modular'
import WoononSubtotalWidget from '@/components/v2/subtotal/WoononSubtotalWidget.vue'
import WoononSubtotalMobileWidget from '@/components/v2/subtotal/WoononSubtotalMobileWidget.vue'
import WoononModularProductsDesktop from '@/components/v2/modular/WoononModularProductsDesktop.vue'
import WoononModularProductsMobile from '@/components/v2/modular/WoononModularProductsMobile.vue'
import WoononPhaseStateMessages from '@/components/v2/WoononPhaseStateMessages.vue'
import WoononPhaseTotal from '@/components/v2/WoononPhaseTotal.vue'
import WoononPhaseCreateOrder from '@/components/v2/WoononPhaseCreateOrder.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Modular',
  setup(__props) {

const showProducts = computed(() => modularStore().elements.length > 0 && (!['loading', 'test'].includes(modularStore().phaseState) || authStore().isInternalDemoAccount))
const orderAllowed = computed(() => modularStore().phaseState === 'open' && !authStore().isDemoCustomer && modularStore().hasSelectedProducts)

onMounted(() => {
  modularStore().getPhaseState()
  modularStore().getModularProducts()
})

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: "modular",
    gutter: [16,4]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Modulaire keuzes",
            loading: _unref(modularStore)().loading
          }, {
            default: _withCtx(() => [
              _createVNode(WoononPhaseStateMessages, {
                phaseState: _unref(modularStore)().phaseState,
                orderReceived: _unref(headerStore)().ordersReceived.modular
              }, null, 8, ["phaseState", "orderReceived"]),
              (_unref(showProducts))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(generalStore)().desktop)
                      ? (_openBlock(), _createBlock(WoononModularProductsDesktop, { key: 0 }))
                      : (_openBlock(), _createBlock(WoononModularProductsMobile, { key: 1 })),
                    _createVNode(WoononPhaseTotal, {
                      phase: "modular",
                      phaseLabel: "modulair"
                    }),
                    (_unref(orderAllowed))
                      ? (_openBlock(), _createBlock(WoononPhaseCreateOrder, {
                          key: 2,
                          phase: "modular",
                          phaseLabel: "Modulair"
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(modularStore)().phaseState === 'open' && !_unref(modularStore)().elements.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Er zijn voor deze fase (nog) geen opties beschikbaar."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }),
      (_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 6
          }, {
            default: _withCtx(() => [
              _createVNode(WoononSubtotalWidget)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(WoononSubtotalMobileWidget, { key: 1 }))
    ]),
    _: 1
  }))
}
}

})